import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom'
import type { AdminUser } from '@manaro/contracts'
import { Logo } from '@/shared/ui/logo.tsx'
import { Spinner } from '@/shared/ui/spinner.tsx'
import { useSession } from './use-session.ts'

interface AuthContext {
  user: AdminUser
}

function SessionLoader() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas">
      <Logo height={24} />
      <span className="flex items-center gap-2 text-[13.5px] text-ink-muted">
        <Spinner className="size-3.5 text-brand" />
        Проверяем доступ…
      </span>
    </div>
  )
}

export function RequireAuth() {
  const location = useLocation()
  const { data, isPending } = useSession()

  if (isPending) return <SessionLoader />
  if (!data) return <Navigate to="/login" replace state={{ from: location.pathname }} />

  return <Outlet context={{ user: data.user } satisfies AuthContext} />
}

export const useCurrentUser = (): AdminUser => useOutletContext<AuthContext>().user
